<script lang="ts">
  import { getContext, setContext } from 'svelte'

  // Props
  export let label: string
  export let path: string

  const breadcrumbs = getContext('breadcrumbs')
  setContext('breadcrumbs', [...breadcrumbs, { label, path }])
</script>

<slot />